module.exports = __webpack_public_path__ + "img/jp.b685c402.jpg";